import { render, staticRenderFns } from "./ChannelGroupSettings.vue?vue&type=template&id=0c20bcf6&"
import script from "./ChannelGroupSettings.vue?vue&type=script&lang=ts&"
export * from "./ChannelGroupSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports